module.exports = __webpack_public_path__ + "static/img/card3.02bfc9f4.jpg";